import { createFileRoute } from '@tanstack/react-router';

import {
  saleListParams,
  saleListQueryOptions,
  saleListSearchSchema,
  SalesPage,
} from '@/features/auctions';

export const Route = createFileRoute('/_authed/_active/s/$storeId/auctions/sales/')({
  staticData: { crumb: 'auctions:nav.sales' },
  validateSearch: saleListSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...saleListQueryOptions(params.storeId, saleListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    if (cause !== 'stay') await prefetch;
  },
  component: SalesPage,
});
